import { render } from "./WalletStats.vue?vue&type=template&id=d5a9da14&scoped=true"
import script from "./WalletStats.vue?vue&type=script&lang=js"
export * from "./WalletStats.vue?vue&type=script&lang=js"

import "./WalletStats.vue?vue&type=style&index=0&id=d5a9da14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a9da14"]])

export default __exports__